'use client';

import { useCountdown } from '@/hooks/useCountdown';

import { splitToTimeComponents } from '@/components/countdown/utils';
import { CountdownTimer } from './Timer';

interface OfferCountdownStatusProps {
  expiry: string | null;
}

export const OfferCountdownStatus = ({ expiry }: OfferCountdownStatusProps) => {
  const currentMs = Date.now();
  const expiryMs = expiry ? new Date(expiry).getTime() : currentMs;

  const duration = useCountdown({
    time: expiryMs - currentMs,
    rateOfChange: 1000,
  });

  const splitTime = splitToTimeComponents(duration);

  return <CountdownTimer timeComponents={splitTime} />;
};
